"use client";

import React from "react";
import { Dialog, Modal } from "staysure-component-library";

import RemoveSureModalContent from "../review-modal-content/remove-sure-modal-content";

type PaymentModalProps = {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
  coverName?: string;
  submitRemove: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: any;
};

function RemoveSureModal({
  isOpen,
  setIsOpen,
  coverName,
  submitRemove,
  content,
}: Readonly<PaymentModalProps>) {
  return (
    <Modal
      onOpenChange={(e: boolean) => setIsOpen(e)}
      isOpen={isOpen}
      modalStyles={{
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
      className=" bg-surface-neutral-option-1 w-[312px] md:w-[416px] items-center justify-center  relative rounded-radius-lg"
      uderlayClassName="z-[200] bg-interactive-overlay-default"
    >
      <Dialog className=" relative" data-testid="remove-sure-dialog">
        <RemoveSureModalContent
          ModalTitle={content.removeModalTitle}
          ModalContent={`${content.removeModalContent} ${
            coverName ? `${coverName}.` : ""
          }`}
          ModalButtonOne={content.removeModalButtonOne}
          ModalButtonTwo={content.removeModalButtonTwo}
          setIsOpen={setIsOpen}
          confirm={submitRemove}
        />
      </Dialog>
    </Modal>
  );
}

export default RemoveSureModal;
